import { Component, EventEmitter, Input, Output, ViewEncapsulation, HostBinding } from '@angular/core';
import {
	MatSlideToggleChange,
	MatSlideToggleModule
} from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

@Component({
	selector: 'copo-slide-button',
	templateUrl: './slide-button.component.html',
	styleUrl: './slide-button.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [NgIf, TranslateModule, MatSlideToggleModule]
})
export class SlideButtonComponent {
	@HostBinding('class.copo-slide-toggle-button') cssClass = true;
	@Input() labelBefore?: string;
	@Input() labelAfter?: string;
	@Input() color = 'primary';
	@Input() checked = false;

	@Output() readonly toggleChange = new EventEmitter<boolean>();

	onToggleChange(eventChange: MatSlideToggleChange) {
		this.checked = eventChange.checked;
		this.toggleChange.emit(eventChange.checked);
	}

	onLabelBeforeClick() {
		this.checked = false;
		this.toggleChange.emit(this.checked);
	}

	onLabelAfterClick() {
		this.checked = true;
		this.toggleChange.emit(this.checked);
	}
}
